import '../InteractiveBlock.css'
import './InteractiveTeleportBlock.css'

export interface InteractiveTeleportBlockProps {
	size: {
		width: 1 | 2
		height: 1 | 2
	}
	image: string
	title: string
	buttons: { text: string, action: () => void }[]
}

export const InteractiveTeleportBlock = (props: InteractiveTeleportBlockProps) => {
	return (
		<div className={`interactive-teleport-block size-width-${props.size.width} size-height-${props.size.height}`}>

			<div className='interactive-teleport-block-inner-wrapper'>
				<div className='interactive-teleport-block-image-wrapper'>
					<img src={`/menupictures/${props.image}.webp`} />
				</div>

				<div className='interactive-teleport-block-content'>
					<h2 className='interactive-teleport-block-title'>{props.title}</h2>

					<div className='interactive-teleport-block-buttons-wrapper'>
						{props.buttons.map((button, index) => (
							<div
								className='interactive-teleport-block-button'
								key={index}
								onClick={button.action}
							>
								{button.text}
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}